import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57e547bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "card p-my-1 p-p-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Open Account Heads", -1))
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "p-field p-col" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-error" }
const _hoisted_9 = {
  key: 1,
  class: "p-error"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_11 = { class: "p-text-center p-p-2 p-mt-3 total-balances" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" TOTAL DEBIT : ")
const _hoisted_13 = { class: "highlight-green" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" TOTAL CREDIT : ")
const _hoisted_15 = { class: "highlight-green" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" DIFF : ")
const _hoisted_17 = { class: "highlight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-check-circle",
              class: "p-button-success",
              label: "Save",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"])),
              disabled: _ctx.getTheTotalDiff != 0
            }, null, 8, ["disabled"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", {
              for: "description",
              class: _normalizeClass({ 'p-error': _ctx.v$.description.$invalid && _ctx.submitted })
            }, "Description", 2),
            _createVNode(_component_InputText, {
              id: "description",
              modelValue: _ctx.v$.description.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.description.$invalid && _ctx.submitted })
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.description.$error && _ctx.submitted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.description.$errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      id: "p-error",
                      key: index
                    }, [
                      _createElementVNode("small", _hoisted_8, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]))
              : (
                (_ctx.v$.description.$invalid && _ctx.submitted) ||
                _ctx.v$.description.$pending.$response
              )
                ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.v$.description.required.$message.replace("Value", "Description")), 1))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.item.itemList,
        scrollable: true,
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_10
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "accountHead",
            header: "Account Name"
          }),
          _createVNode(_component_Column, {
            field: "accountNature",
            header: "Account Nature"
          }),
          _createVNode(_component_Column, {
            header: "DEBIT",
            style: {"width":"20%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                useGrouping: false,
                maxFractionDigits: 2,
                minFractionDigits: 2,
                modelValue: slotProps.data.debitAmount,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.debitAmount) = $event),
                disabled: slotProps.data.creditAmount > 0,
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "CREDIT",
            style: {"width":"20%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                useGrouping: false,
                maxFractionDigits: 2,
                minFractionDigits: 2,
                modelValue: slotProps.data.creditAmount,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.creditAmount) = $event),
                disabled: slotProps.data.debitAmount > 0,
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _createElementVNode("h4", _hoisted_11, [
        _createElementVNode("b", null, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalDebitAmount)), 1),
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalCreditAmount)), 1),
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.getTheTotalDiff)), 1)
        ])
      ])
    ])
  ]))
}